import { useLayoutEffect } from '@react-aria/utils';

/** A version of `useLayoutEffect` that runs synchronously during SSR. */
export const useServerLayoutEffect: typeof useLayoutEffect =
  typeof document !== 'undefined' ? useLayoutEffect : (effect) => effect();
